import "./scss/App.scss";
import NewsCategories from "./pages/News/Categories/NewsCategories";
import NewsRecords from "./pages/News/Records/NewsRecords";
import Users from "./pages/UsersPage/Users";
import {Route, Routes} from "react-router-dom";
import AuthForm from "./components/auth/AuthForm";
import useLogin from "./components/auth/useLogin";
import React, {lazy, useEffect} from "react";
import Dashboard from "./pages/DashboardPage/Dashboard";
import NoMatch from "./components/nomatch-component/NoMatch";
import Spinner from "./components/spinner-component/Spinner";
import SettingsPage from "./pages/SettingsPage/SettingsPage";
import RecordsPage from "./pages/AboutUs/Records/RecordsPage";
import CategoriesPage from "./pages/AboutUs/Categories/CategoriesPage";
import VacanciesCategoriesPage from "./pages/Vacancies/Categories/VacanciesCategories";
import VacanciesPostsPage from "./pages/Vacancies/Records/VacanciesPosts";
import TransportationToOrderCategoriesPage
    from "./pages/TransportationToOrder/Categories/TransportationToOrderCategories";
import TransportationToOrderPostsPage from "./pages/TransportationToOrder/Records/TransportationToOrderPosts";
import RoadToAirportCategoriesPage from "./pages/RoadToAirport/Categories/RoadToAirportCategories";
import RoadToAirportRecordsPage from "./pages/RoadToAirport/Records/RoadToAirportRecords";
import InformationForTouristsCategoriesPage
    from "./pages/InformationForTourists/Categories/InformationForTouristsCategories";
import InformationForTouristsRecordsPage from "./pages/InformationForTourists/Records/InformationForTouristsRecords";
import InternationalProjectsCategoriesPage
    from "./pages/InternationalProjects/Categories/InternationalProjectsCategories";
import InternationalProjectsRecordsPage from "./pages/InternationalProjects/Records/InternationalProjectsRecords";
import ElectricitySupplyCategoriesPage from "./pages/ElectricitySupply/Categories/ElectricitySupplyCategories";
import ElectricitySupplyRecordsPage from "./pages/ElectricitySupply/Records/ElectricitySupplyRecords";
import RoadSituationCategoriesPage from "./pages/RoadSituation/Categories/RoadSituationCategories";
import RoadSituationRecordsPage from "./pages/RoadSituation/Records/RoadSituationRecords";
import LanguagesList from "./pages/LanguagePage/Languages/LanguagesList";
import DriversSchool from "./pages/DriversSchoolPage/Records/DriversSchool";
import DriversSchoolCategoriesPage from "./pages/DriversSchoolPage/Categories/DriversSchoolCategories";
import Subscribers from "./pages/Subscribers/Subscribers";
import TicketCategories from "./pages/Ticket/Categories/TicketCategories";
import TicketRecords from "./pages/Ticket/Records/TicketRecords";
import {Storage} from "./apiHelper/Storage";

const storage = Storage();

const MainLayout = lazy(() => import("./layout/MainLayout"));


/**
 * Parent components
 *
 * @returns JSX
 */
const App = () => {
    const {
        Login,
        Logout,
        isLogin,
        isLoading,
        errorMessage,
        user_password,
        adminErrorMsg,
        handleChangeName,
        handleChangePassword,
        fetchUserInfo,
        user_data,
        user_name,
        isLoadingInit,
        setLoadingInit
    } = useLogin();

    useEffect(() => {
        const init = async () => {
            if (isLogin) {
                setLoadingInit(false)
                return
            }

            const token = storage.get("token")
            if (!token) {
                setLoadingInit(false)
                return
            }
            setLoadingInit(true)
            try {
                await fetchUserInfo(token, true)
                setLoadingInit(false)
            } catch (e) {
                console.log(e)
                setLoadingInit(false)
            }
        }
        init()
    }, [])

    if (isLoading || isLoadingInit) {
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "100dvh",
                    overflow: 'hidden'
                }}
            >
                <Spinner/>
            </div>
        );
    }

    return (
        <>
            {isLogin ? (
                <Routes>
                    <Route
                        path="/"
                        element={
                            <MainLayout
                                logout={Logout}
                                user_picture={user_data?.picture}
                                user_name={user_data?.given_name}
                                user_family_name={user_data?.family_name}
                            />
                        }
                    >
                        <Route index element={<Dashboard/>}/>
                        <Route path="news/categories" element={<NewsCategories/>}/>
                        <Route path="news/records" element={<NewsRecords/>}/>
                        <Route path="users" element={<Users/>}/>
                        <Route path="subscribers" element={<Subscribers/>}/>
                        <Route path="about-us/categories" element={<CategoriesPage/>}/>
                        <Route path="about-us/records" element={<RecordsPage/>}/>
                        <Route path="vacancies/categories" element={<VacanciesCategoriesPage/>}/>
                        <Route path="vacancies/records" element={<VacanciesPostsPage/>}/>
                        <Route path="services/categories" element={<TransportationToOrderCategoriesPage/>}/>
                        <Route path="services/records" element={<TransportationToOrderPostsPage/>}/>
                        <Route path="road-to-aeroports/categories" element={<RoadToAirportCategoriesPage/>}/>
                        <Route path="road-to-aeroports/records" element={<RoadToAirportRecordsPage/>}/>
                        <Route path="information-for-tourists/categories"
                               element={<InformationForTouristsCategoriesPage/>}/>
                        <Route path="information-for-tourists/records"
                               element={<InformationForTouristsRecordsPage/>}/>
                        <Route path="international-projects/categories"
                               element={<InternationalProjectsCategoriesPage/>}/>
                        <Route path="international-projects/records" element={<InternationalProjectsRecordsPage/>}/>
                        <Route path="electricity-supply/categories" element={<ElectricitySupplyCategoriesPage/>}/>
                        <Route path="electricity-supply/records" element={<ElectricitySupplyRecordsPage/>}/>
                        <Route path="road-situation/categories" element={<RoadSituationCategoriesPage/>}/>
                        <Route path="road-situation/records" element={<RoadSituationRecordsPage/>}/>
                        <Route path="ticket/categories" element={<TicketCategories/>}/>
                        <Route path="ticket/records" element={<TicketRecords/>}/>
                        <Route path="driving-school/records" element={<DriversSchool/>}/>
                        <Route path="driving-school/categories" element={<DriversSchoolCategoriesPage/>}/>
                        <Route path="language" element={<LanguagesList/>}/>
                        <Route path="settings" element={<SettingsPage/>}/>
                    </Route>
                    <Route path="*" element={<NoMatch/>}/>
                </Routes>
            ) : (
                <AuthForm
                    Login={Login}
                    user_name={user_name}
                    errorMessage={errorMessage}
                    user_password={user_password}
                    adminErrorMsg={adminErrorMsg}
                    handleChangeName={handleChangeName}
                    handleChangePassword={handleChangePassword}
                />
            )}
        </>
    );
};

export default App;
